import  Axios  from 'axios';

const root=window.location.hostname.split(".")

export const getAxiosTotall=()=>{
    return Axios.create({
        baseURL:`https://apid.${root[0]==="localhost"?"barest":root[1]}.ir/`,
        headers: {
            "x-auth-token": localStorage.getItem("JwtTokens")
        }
    })
}
export const getAxiosNotif=()=>{
    return Axios.create({
        baseURL:"https://api.barest.ir/",
        headers: {
            "x-auth-token": localStorage.getItem("JwtTokens")
        }
    })
}